export const homeAr = {
  home: 'الرئيسية',
  about: 'من نحن',
  projects: 'مشاريع الجمعية',
  statistics: 'احصائيات',
  services: 'خدماتنا',
  contact: 'اتصل بنا',
  heroTitle: 'جمعية الفلاح للأعمال الإجتماعية والثقافية',
  associationName: 'جمعية الفلاح',
  heroSubtitle: 'نظام إدارة الحلقات - منصة متكاملة لإدارة حلقات تحفيظ القرآن الكريم',
  adminLogin: 'دخول المدير',
  teacherLogin: 'دخول الأستاذ',
  parentLogin: 'دخول ولي الأمر',
  aboutTitle: 'من نحن',
  aboutText: 'جمعية الفلاح للأعمال الإجتماعية والثقافية هي منظمة خيرية تهدف إلى تعزيز القيم الإسلامية والثقافية في المجتمع. نحن نركز على إدارة حلقات تحفيظ القرآن الكريم وتقديم الخدمات التعليمية والثقافية للمجتمع.',
  readMore: 'إقرأ المزيد',
  projectsTitle: 'خدماتنا الرئيسية',
  project1Title: 'إدارة الطلاب',
  project1Desc: 'نظام متكامل لإدارة بيانات الطلاب ومتابعة تقدمهم في حفظ القرآن الكريم مع إمكانية إضافة وتعديل البيانات.',
  project2Title: 'إدارة الدرجات',
  project2Desc: 'نظام تقييم شامل لتسجيل درجات الطلاب ومتابعة أدائهم في الحلقات مع إمكانية إرسال التقارير لأولياء الأمور.',
  project3Title: 'التواصل مع أولياء الأمور',
  project3Desc: 'منصة تواصل فعالة بين الأساتذة وأولياء الأمور لإرسال الرسائل والتقارير ومتابعة تقدم الطلاب.',
  project4Title: 'إدارة الأساتذة',
  project4Desc: 'نظام إدارة شامل للأساتذة مع إمكانية متابعة أدائهم وتقييمهم وإدارة جداولهم الدراسية.',
  statsTitle: 'إحصائيات الجمعية',
  statStudents: 'طالب وطالبة',
  statTeachers: 'أستاذ وأستاذة',
  statCircles: 'حلقة',
  statParents: 'ولي أمر',
  servicesTitle: 'خدماتنا',
  service1Title: 'حلقات تحفيظ القرآن',
  service1Desc: 'حلقات متخصصة لتحفيظ القرآن الكريم بأساليب حديثة ومتطورة',
  service2Title: 'التعليم الديني',
  service2Desc: 'برامج تعليمية شاملة للعلوم الشرعية والفقهية',
  service3Title: 'الأنشطة الثقافية',
  service3Desc: 'فعاليات وبرامج ثقافية متنوعة لتعزيز القيم الإسلامية',
  service4Title: 'الخدمات الاجتماعية',
  service4Desc: 'برامج ومبادرات اجتماعية لخدمة المجتمع',
  footerText: 'جميع الحقوق محفوظة - مؤسسة أثر للقرآن',
  footerPoweredBy: 'تستخدم هذا البرنامج: جمعية الفلاح للأعمال الإجتماعية والثقافية',
  privacyPolicy: 'سياسة الخصوصية',
  contactUs: 'اتصل بنا',
  address: 'العنوان: المملكة المغربية',
  phone: 'الهاتف: +212 XX XXX XXXX',
  email: 'البريد الإلكتروني: info@alfalah.org',

  // Formulaire contact public
  contactFormTitle: 'أرسل لنا رسالة',
  contactName: 'الاسم الكامل',
  contactPhone: 'الهاتف',
  contactEmail: 'البريد الإلكتروني',
  contactSubject: 'الموضوع',
  contactMessage: 'الرسالة',
  contactSend: 'إرسال الرسالة',
  contactSending: 'جارٍ الإرسال...',
  contactPhoneOrEmailHint: 'يجب إدخال الهاتف أو البريد الإلكتروني على الأقل',
  contactSuccess: 'تم الإرسال بنجاح!',
  contactSuccessMsg: 'شكرًا لتواصلك معنا. سنرد عليك في أقرب وقت.',
  contactRefLabel: 'رقم طلبك',
  contactErrName: 'يرجى إدخال الاسم الكامل',
  contactErrSubject: 'يرجى إدخال الموضوع',
  contactErrMsg: 'يرجى إدخال رسالتك (10 أحرف على الأقل)',
  contactErrPhoneOrEmail: 'يرجى إدخال رقم الهاتف أو البريد الإلكتروني',
  contactErrGeneric: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
  contactErrLimit: 'عدد كبير من الطلبات. يرجى المحاولة لاحقًا.',
  contactSendNew: 'إرسال رسالة أخرى',

  // Demande d'inscription
  inscriptionBtn: 'طلب التسجيل',
  inscriptionTitle: 'طلب التسجيل',
  inscriptionSubtitle: 'أكمل البيانات التالية لتقديم طلب التسجيل',
  inscriptionTypeLabel: 'نوع الطلب',
  inscriptionTypeParent: 'ولي أمر',
  inscriptionTypeTeacher: 'أستاذ',
  inscriptionParentModeNew: 'ولي أمر جديد',
  inscriptionParentModeExisting: 'ولي أمر مسجل مسبقًا',
  inscriptionName: 'الاسم الكامل',
  inscriptionPhone: 'الهاتف',
  inscriptionEmail: 'البريد الإلكتروني (اختياري)',
  inscriptionGender: 'الجنس',
  inscriptionGenderMale: 'ذكر',
  inscriptionGenderFemale: 'أنثى',
  inscriptionAddress: 'العنوان (اختياري)',
  inscriptionNotes: 'ملاحظات (اختياري)',
  inscriptionExistingUsername: 'اسم المستخدم',
  inscriptionExistingPassword: 'كلمة المرور',
  inscriptionChildrenTitle: 'بيانات الأبناء',
  inscriptionChildName: 'اسم الطالب',
  inscriptionChildLevel: 'المستوى',
  inscriptionChildHalqa: 'الحلقة',
  inscriptionChildNotes: 'ملاحظات',
  inscriptionAddChild: '+ إضافة ابن/ابنة',
  inscriptionRemoveChild: 'حذف',
  inscriptionVerify: 'تحقق',
  inscriptionVerifying: 'جارٍ التحقق...',
  inscriptionChange: 'تعديل',
  inscriptionExistingChildren: 'الأبناء المسجلون مسبقاً',
  inscriptionNewChildren: 'أبناء جدد للتسجيل',
  inscriptionRenewSection: 'إعادة تسجيل الأبناء',
  inscriptionAlreadyRenrolled: 'مسجّل مجدداً',
  inscriptionSelected: 'محدد',
  inscriptionSelectRenroll: 'إعادة تسجيل',
  inscriptionErrAtLeastOne: 'حدد على الأقل إعادة تسجيل واحدة أو أضف ابناً جديداً',
  inscriptionNoChildrenFound: 'لا يوجد أبناء مرتبطون بهذا الحساب',
  inscriptionTeacherTitle: 'بيانات المعلم',
  inscriptionHalqa: 'الحلقة المخصصة',
  inscriptionExperience: 'سنوات الخبرة (اختياري)',
  inscriptionSpecialization: 'التخصص (اختياري)',
  inscriptionCertDate: 'تاريخ الإجازة (اختياري)',
  inscriptionSubmit: 'إرسال الطلب',
  inscriptionSubmitting: 'جارٍ الإرسال...',
  inscriptionSuccess: 'تم إرسال طلبك بنجاح!',
  inscriptionSuccessMsg: 'سيتم مراجعة طلبك والتواصل معك قريبًا.',
  inscriptionRequestNumber: 'رقم طلبك',
  inscriptionBack: 'العودة',
  inscriptionErrName: 'يرجى إدخال الاسم الكامل',
  inscriptionErrPhone: 'يرجى إدخال رقم الهاتف',
  inscriptionPhoneMissingHint: 'لا يوجد رقم هاتف مسجل في حسابكم: يرجى إدخاله لإتمام الطلب.',
  inscriptionErrHalqa: 'يرجى تحديد الحلقة',
  inscriptionErrChildName: 'يرجى إدخال اسم الطالب',
  inscriptionErrGeneric: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
  inscriptionErrLimit: 'عدد كبير من الطلبات. يرجى المحاولة لاحقًا.',
  inscriptionErrCredentials: 'بيانات الدخول غير صحيحة.',
  inscriptionErrParentMode: 'يرجى اختيار نوع طلب ولي الأمر',
  inscriptionErrCredentialsRequired: 'يرجى إدخال اسم المستخدم وكلمة المرور',
  inscriptionLvlNursery: 'الروض',
  inscriptionLvl1: 'الأول',
  inscriptionLvl2: 'الثاني',
  inscriptionLvl3: 'الثالث',
  inscriptionLvl4: 'الرابع',
  inscriptionLvl5: 'الخامس',
  inscriptionLvlPrep: 'الإعدادي',
  inscriptionHalqaListen: 'حلقة الحفظ بالسمع',
  inscriptionHalqaMushaf: 'حلقة الحفظ بالمصحف',
  inscriptionHalqaReview: 'حلقة المراجعة',
  inscriptionChild: 'ابن/ابنة',
  inscriptionOptional: 'اختياري',

  // Fondation Athar
  foundationName: 'مؤسسة أثر للقرآن',
  foundationAbout: 'مؤسسة تعنى بنشر تعاليم القرآن الكريم وتيسير حفظه وتلاوته',
  foundationContact: 'تواصل مع المؤسسة',
  foundationEmail: 'atharalquran.org@gmail.com',
  foundationPhone: '+212767532742',
  foundationInfoTitle: 'عن مؤسسة أثر للقرآن',
  foundationModalSubtitle: 'تطبيق مجاني لإدارة حلقات تحفيظ القرآن الكريم',
  foundationModalBody: 'تطبيق مجاني طوّرته مؤسسة أثر للقرآن الكريم، موجَّه لجميع جمعيات ومؤسسات تحفيظ القرآن الكريم.\n\nيوفّر ثلاثة فضاءات مستقلة: المدير، الأستاذ، وولي الأمر.\n\nيتيح إدارة الطلاب والأساتذة، متابعة سجلات الحفظ والتقدم القرآني، تسجيل النقاط والامتحانات، تتبع المالية، والتواصل الداخلي بين جميع الأطراف.\n\nمتوفر بثلاث لغات: العربية، الفرنسية، والإنجليزية.\n\nمتوفر على الويب، وأندرويد، وiOS.',
  foundationEmailBtn: 'بريد إلكتروني',
  foundationCallBtn: 'اتصال',
  foundationClose: 'إغلاق',
  foundationComposeTitle: 'مراسلة المؤسسة',
  foundationComposeTo: 'إلى:',
  foundationYourName: 'اسمك',
  foundationNamePlaceholder: 'الاسم الكامل',
  foundationYourEmail: 'بريدك الإلكتروني',
  foundationEmailPlaceholder: 'email@example.com',
  foundationYourPhone: 'الهاتف',
  foundationPhonePlaceholder: '+212767532742',
  foundationSubject: 'الموضوع',
  foundationSubjectPlaceholder: 'موضوع رسالتك',
  foundationMessage: 'الرسالة',
  foundationMessagePlaceholder: 'رسالتك هنا...',
  foundationSend: 'إرسال',
  foundationDefaultSubject: 'رسالة من منصة الفلاح',
  foundationErrRequired: 'يرجى ملء الاسم والرسالة.',
  foundationWriteEmail: 'مراسلة المؤسسة',
};

